import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogInComponent } from './log-in/log-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FacturacionComponent } from './facturacion/facturacion.component';
import { FacturacionLineaComponent } from './facturacion-linea/facturacion-linea.component';
import { DescargasPdfXmlComponent } from './descargas-pdf-xml/descargas-pdf-xml.component';
import { PdfHtmlComponent } from './pdf-html/pdf-html.component';
import { FacturaGlobalComponent } from './factura-global/factura-global.component';
import { NotasCreditoComponent } from './notas-credito/notas-credito.component';
import { ComplementosPagosComponent } from './complementos-pagos/complementos-pagos.component';
import { CrearFacturaComponent } from './crear-factura/crear-factura.component';
import { LlistadoNotasCreditoComponent } from './llistado-notas-credito/llistado-notas-credito.component';


const routes: Routes = [
  {
    path: "",
    component: FacturacionLineaComponent
  }, {
    path: "notasCredito",
    component: NotasCreditoComponent
  }, {
    path: "listado-notas-credito",
    component: LlistadoNotasCreditoComponent
  }, {
    path: "complementosPagos",
    component: ComplementosPagosComponent
  }, {
    path: "descargasPdfXml/:uuid",
    component: DescargasPdfXmlComponent
  }, {
    path: "facturaGlobal",
    component: FacturaGlobalComponent
  }, {
    path: "login",
    component: LogInComponent
  }, {
    path: "signUp",
    component: SignUpComponent
  }, {
    path: "dashBoard",
    component: DashboardComponent
  }, {
    path: "facturacion",
    component: FacturacionComponent
  }, {
    path: "crear-factura",
    component: CrearFacturaComponent
  }, {
    path: "posFact/:uuid",
    component: PdfHtmlComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
